import React, { useEffect, useState } from "react";
import {
  Alert,
  Box,
  Button,
  Dialog,
  DialogContent,
  DialogTitle,
  IconButton,
  FormControl,
  FormControlLabel,
  Grid,
  InputLabel,
  InputAdornment,
  MenuItem,
  Select,
  Switch,
  TextField,
  DialogActions
} from "@mui/material";
import AttachMoneyOutlinedIcon from "@mui/icons-material/AttachMoneyOutlined";
import { capitalize } from "../../common/component/util";
import PercentIcon from "@mui/icons-material/Percent";
import CloseIcon from "@mui/icons-material/Close";

export default function ProductFieldOption(props) {
  const { mode, value, category } = props;

  const [name, setName] = useState("");
  const [description, setDescription] = useState("");

  const [type, setType] = useState("");
  const [amountType, setAmountType] = useState("fixed");
  const [amount, setAmount] = useState("");

  const [errors, setErrors] = useState([]);

  const [open, setOpen] = useState(false);

  const validate = () => {
    let arr = [];

    if (amount) {
      if (isNaN(+amount)) {
        arr.push("Invalid Surcharge");
      }
      if (+amount >= 100) {
        arr.push("Surcharge can't be 100 or more");
      }
    }
    return arr;
  };

  const submit = (e) => {
    e.preventDefault();
    e.stopPropagation();

    let arr = validate();
    setErrors(arr);
    if (arr.length > 0) {
      return;
    } else {
      let o = { name, description };
      if (type === "surcharge") {
        if (amountType === "variable") {
          o.pricing = { type, factor: (amount / 100).toFixed(2) };
        } else {
          o.pricing = { type, amount };
        }
      }
      props.onChange(o);
      setOpen(false);
      handleClose();
    }
  };

  const handleDelete = () => {
    props.onChange("");
    setOpen(false);
    handleClose();
  };

  const handleClose = () => {
    setName("");
    setDescription("");
    setType("");
    setAmount("");
    setAmountType("");
    setOpen(false);
  };

  return (
    <>
      <span
        onClick={() => {
          setName(value?.name || "");
          setDescription(value.description || "");

          setType(value.pricing?.type || "");
          setAmount(value.pricing?.amount || "");
          setAmountType("");

          if (value.pricing) {
            setType("surcharge");
            if (value.pricing.factor) {
              setAmountType("variable");
              setAmount((100 * value.pricing?.factor).toFixed(2));
            } else if (value.pricing.amount) {
              setAmountType("fixed");
            }
          }

          setOpen(true);
        }}
      >
        {props.children}
      </span>

      <Dialog open={open} onClose={handleClose}>
        <form onSubmit={submit}>
          <DialogTitle>
            {`${capitalize(mode)} ${category} Option`}{" "}
            <IconButton
              onClick={handleClose}
              sx={{
                position: "absolute",
                right: 8,
                top: 8
              }}
            >
              <CloseIcon />
            </IconButton>
          </DialogTitle>
          <DialogContent>
            <Box py={2}>
              <Grid container spacing={3}>
                <Grid item xs={12}>
                  <TextField
                    name="name"
                    value={name}
                    variant="outlined"
                    fullWidth
                    id="name"
                    label="Name"
                    inputProps={{ maxLength: 40 }}
                    onChange={(e) => setName(e.target.value)}
                    required
                  />
                </Grid>
                <Grid item sm={12} xs={12}>
                  <TextField
                    name="description"
                    value={description}
                    variant="outlined"
                    fullWidth
                    id="description"
                    label="Description (optional)"
                    inputProps={{ maxLength: 100 }}
                    onChange={(e) => setDescription(e.target.value)}
                    helperText="A short description to help customers compare options"
                  />
                </Grid>
                <Grid item xs={12} sm={12}>
                  <FormControlLabel
                    control={<Switch checked={type === "surcharge"} onChange={(e) => setType(e.target.checked ? "surcharge" : "")} />}
                    label="Premium option (Surcharge)"
                  />
                </Grid>
              </Grid>
              {type === "surcharge" && (
                <Box pl={6}>
                  <Box my={3}>
                    <FormControl variant="outlined" required fullWidth>
                      <InputLabel id="amountType-option-label">Surcharge Type</InputLabel>
                      <Select
                        value={amountType}
                        labelId="amountType-label"
                        label="Surcharge Type"
                        id="amountType"
                        name="amountType"
                        onChange={(e) => setAmountType(e.target.value.trim())}
                      >
                        <MenuItem value="fixed">Fixed (dollar amount)</MenuItem>
                        <MenuItem value="variable">Percentage (of base price)</MenuItem>
                      </Select>
                    </FormControl>
                  </Box>
                  <Box my={3}>
                    <TextField
                      name="amount"
                      value={amount}
                      variant="outlined"
                      id="amount"
                      label="Surcharge"
                      onChange={(e) => setAmount(e.target.value)}
                      onWheel={(e) => {
                        e.target && e.target.blur();
                      }}
                      type="text"
                      onInvalid={(e) => e.target.setCustomValidity("Enter a valid amount")}
                      onInput={(e) => e.target.setCustomValidity("")}
                      required
                      InputProps={{
                        startAdornment: (
                          <InputAdornment position="start">
                            {amountType === "variable" ? <PercentIcon /> : <AttachMoneyOutlinedIcon />}
                          </InputAdornment>
                        )
                      }}
                      helperText={
                        amountType === "variable"
                          ? "Enter percentage (e.g. 10 for 10%)"
                          : "Enter dollar amount (e.g. 5.00 for $5.00)"
                      }
                    />
                  </Box>
                </Box>
              )}
              {errors?.length > 0 && (
                <Box my={2}>
                  <Alert severity="error">{errors.join(". ")}</Alert>
                </Box>
              )}
            </Box>
          </DialogContent>
          <DialogActions>
            <Grid container>
              <Grid item xs={4}>
                {mode === "Edit" && (
                  <Button onClick={handleDelete} style={{ color: "#e74c3c" }}>
                    Remove
                  </Button>
                )}
              </Grid>
              <Grid item xs={8}>
                <Box align="right">
                  <Button style={{ marginRight: "15px" }} onClick={handleClose}>
                    Cancel
                  </Button>
                  <Button variant="contained" color="primary" type="submit">
                    {mode === "Edit" ? "Update" : "Add"}
                  </Button>
                </Box>
              </Grid>
            </Grid>
          </DialogActions>
        </form>
      </Dialog>
    </>
  );
}
